import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { debounceTime } from 'rxjs';
import { LoaderService } from './core/services/loader.service';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'emp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, LoaderComponent, CommonModule]
})
export class AppComponent {
  private loaderService = inject(LoaderService);

  public pending$ = this.loaderService.isLoading.pipe(debounceTime(500));
}
